// extracted by css-extract-rspack-plugin
export default {"root":"src-features-Integrations-components-NodeStatus-assets-NodeStatus-module__root-gu3xYl","loadingContent":"src-features-Integrations-components-NodeStatus-assets-NodeStatus-module__loadingContent-r65eso"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-features-Integrations-components-NodeStatus-assets-NodeStatus-module__root-gu3xYl\",\"loadingContent\":\"src-features-Integrations-components-NodeStatus-assets-NodeStatus-module__loadingContent-r65eso\"}";
        // 1791855167450
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  